var chunkToChildrenMap = {
	"849": [
		545,
		967,
		193,
		149,
		917,
		180,
		737,
		813,
		718,
		379,
		910
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));